import {InjectionToken} from '@angular/core';
import {Observable} from 'rxjs';
import {ListResponse} from '../../common/api-helpers';
import {CommonListFilter} from '../../models/filters/common-list-filter';
import {Security} from '../../models/security';

export interface CustomSecurityRequestHandler<T extends Security = Security> {
    isRestFilterMatch: (listFilter: CommonListFilter) => boolean;
    fetch: (listFilter: CommonListFilter) => Observable<ListResponse<T>>;
}

export const CUSTOM_SECURITY_REQUEST_HANDLERS = new InjectionToken<CustomSecurityRequestHandler[]>(
    'customSecurityRequestHandlers',
    {
        factory: () => []
    }
);
